import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgPin = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12.773 23.603c2.126-2.869 7.901-11.02 7.901-14.929a8.674 8.674 0 0 0-17.348 0c0 3.909 5.775 12.06 7.9 14.929a.957.957 0 0 0 1.547 0M12 11.186a3.317 3.317 0 1 0 0-6.634 3.317 3.317 0 0 0 0 6.634"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgPin);
export default Memo;
